<script>
import DatePicker from "vue2-datepicker";
export default {
    name: "JournalReports",
    components: {
        DatePicker,
    },
    props: {
        fundClusters: {
            type: Array,
            required: false,
            default: () => [],
        },
        months: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            reportList: false,
            selectedMonth: new Date().getMonth() + 1,
            selectedFundCluster: null,
            selectedRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)],
        };
    },
    methods: {
        generateReport(){
            if(this.selectedRange && this.selectedFundCluster){
                const reportParams = {
                    date: this.selectedRange,
                    fundCluster: this.selectedFundCluster,
                };
                this.$emit('generate-report', reportParams);
            }
        },
    },
};
</script>
<template>
    <div>
        <b-button id="journal-select-report" variant="purple">
            <i class="bx bx-printer align-middle me-2"></i>Generate Journal
        </b-button>
        <b-popover
            target="journal-select-report"
            triggers="click"
            placement="left"
            custom-class="popover-report"
            :show.sync="reportList"
        >
            <template v-slot:title>
                <div class="d-flex align-items-center justify-content-between">
                    <small>Report Options</small>
                    <span 
                        class="bx bx-x font-size-14 cursor-pointer"
                        @click="reportList = false"
                    ></span>
                </div>
            </template>
            <div class="my-3">
                <div class="mx-3 mb-3">
                    <label for="monthSelect" class="mb-0">Select Date Range</label>
                    <!-- <select 
                        class="form-select"
                        v-model="selectedMonth"
                    >
                        <option value="">Select a month</option>
                        <option 
                            v-for="month in months" 
                            :key="month.value"
                            :value="month.value"
                        >
                            {{ month.text }}
                        </option>
                    </select> -->
                    <date-picker
                        v-model="selectedRange"
                        :first-day-of-week="1"
                        lang="en"
                        range
                        placeholder="Enter Date..."
                    >
                    </date-picker>
                </div>
                <div class="mx-3 mb-3">
                    <label for="fcSelect" class="mb-0">Select Fund Cluster</label>
                    <select 
                        class="form-select"
                        v-model="selectedFundCluster"
                    >
                        <option 
                            v-for="fundCluster in fundClusters" 
                            :key="fundCluster.value"
                            :value="fundCluster.value"
                        >
                            {{ fundCluster.text }}
                        </option>
                    </select>
                </div>
                <div class="mx-3 mb-3" v-if="selectedMonth && selectedFundCluster">
                    <button 
                        class="btn btn-purple w-100"
                        @click="generateReport()"
                    >
                        <i class="bx bx-printer"></i> Generate Report
                    </button>
                </div>
            </div>
        </b-popover>
    </div>
</template>